/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumResearchTourElement {
	AppToggleBtn 		   	   = 'product_tour_app_toggle_btn',
	TmSearchAdvancedOptions	   = 'product_tour_tm_search_advanced_options',
	TmSearchAdvancedOptionsBtn = 'product_tour_tm_search_advanced_options_btn',
	ResearchTutorials		   = 'product_tour_research_tutorials',
	DummyDomElement 		   = 'dummy_dom_element'
}
